export default "__VITE_ASSET__DtNR7Jms__"